export default "__VITE_ASSET__Cil7XNK___"